// Extra constants can be defined here
export const HOST_URL = "https://demo.smts.org.in/api";
